/* import __COLOCATED_TEMPLATE__ from './custom-dropdown-option-item.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import { type PaletteColor } from '@intercom/pulse/template-registry';

interface Item {
  text: string;
  description?: string;
  isSelected?: boolean;
  icon: InterfaceIconName;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}
interface Args {
  item: Item;
}

export default class ReportingCustomReportCustomDropdownOptionItem extends Component<Signature> {
  get iconColor(): PaletteColor {
    return this.args.item.isSelected ? 'accent-fill' : 'text-default';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::CustomDropdownOptionItem': typeof ReportingCustomReportCustomDropdownOptionItem;
    'reporting/custom/report/custom-dropdown-option-item': typeof ReportingCustomReportCustomDropdownOptionItem;
  }
}
